import qs from "qs";
import _ from "lodash";
import castit from "castit";

import state from "../state";


export function captureQueryString() {
	const queryString = qs.parse(window.location.search, { ignoreQueryPrefix: true });
	let _queryString = {};
	_.forEach(queryString, (value, key) => {
		_queryString[key] = castit(value);
	});
	// console.log("CAPTURED QUERY STRING", _queryString);

	try {
		/* eslint-disable */
		if (defaultParams) {
			_queryString = _.assign({}, defaultParams, _queryString);
		}
		/* eslint-enable */
	} catch (e) {
		console.warn(e);
	}
	// console.log("Final QUERY STRING", _queryString);
	state.set(["_config"], _queryString);
}

export function getConfigParam(key, defaultValue=null) {
	let result = defaultValue;
	if (key) {
		if (!state.exists(["_config"])) {
			captureQueryString();
		}

		if (state.exists(["_config", key])) {
			result = state.get(["_config", key]);
		} else if (state.exists(["config", key])) {
			// Fallback for web player integration into other app
			result = state.get(["config", key]);
			// console.log("Fallback", key, result);
		}
	}

	return result;
}

const AVAILABLE_STYLING_OPTIONS = ["fontColor", "backgroundColor", "backgroundMediaUrl", "fontWeight", "fontFamily","swiperButtonsColor"];

export function injectCustomStyling() {
	const styleOverrides = [];
	const styleOverridesTargeted = [];
	AVAILABLE_STYLING_OPTIONS.forEach(option => {
		let val = getConfigParam(option);
		if (val) {
			switch (option) {
				case "fontColor": {
					styleOverrides.push(`color: ${val};`);
					break;
				}
				case "fontWeight": {
					styleOverrides.push(`font-weight: ${val};`);
					break;
				}
				case "fontFamily": {
					styleOverrides.push(`font-family: ${val}!important;`);
					break;
				}
				case "backgroundColor": {
					styleOverrides.push(`background-color: ${val};`);
					break;
				}
				case "swiperButtonsColor": {
					styleOverridesTargeted.push(`.swiper-button-prev { background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg transform='scale(4)'%3E%3Cpath style='fill:%23${val}' d='m 14 1 L 20 1 L 10 12 L 20 23 L 14 23 L 4 12 Z'/%3E%3C/g%3E%3C/svg%3E")!important;}`);
					styleOverridesTargeted.push(`.swiper-button-next { background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg transform='scale(4) rotate(180 12 12)'%3E%3Cpath style='fill:%23${val}' d='m 14 1 L 20 1 L 10 12 L 20 23 L 14 23 L 4 12 Z'/%3E%3C/g%3E%3C/svg%3E")!important;}`);
					styleOverridesTargeted.push(`.swiper-pagination .swiper-pagination-bullet {background-color:${val};}`);
					break;
				}	
				case "backgroundMediaUrl": {
					styleOverrides.push(`
						background: url('${val}') no-repeat center center fixed; 
						-webkit-background-size: cover;
						-moz-background-size: cover;
						-o-background-size: cover;
						background-size: cover;
					`);
					break;
				}
				default: {
					// console.log("Unhandled styling option", option);
				}
			}
		}
	});
	// console.log("Provided overrides", styleOverrides);
	if (!_.isEmpty(styleOverrides) || !_.isEmpty(styleOverridesTargeted)) {
		const styleEl = document.createElement("style");
		styleEl.type = "text/css";
		let val= "";
		if (!_.isEmpty(styleOverrides)) {
			val += `body {${styleOverrides.join("\n")}}`;
		}
		if (!_.isEmpty(styleOverridesTargeted)) {
			val += styleOverridesTargeted.join("\n");
		}
		styleEl.innerHTML = val;
		// console.log("Injecting styles")
		document.getElementsByTagName("head")[0].appendChild(styleEl);
	}
}